import React, { FormEvent, useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { abpnClient, IdentityServerKnownClient } from "../../Services/AbpnClient";
import ActivateUser from "./Models/ActivateUser";
import SearchPhysicianModel from "./Models/SearchPhysicianModel";

interface IProps {
    model: SearchPhysicianModel;
    onSave: (userModel: ActivateUser) => void;
}
export default function UpdateEmail(props: IProps) {
    const [email, setEmail] = useState<string>("");
    const [emailUnavilable, setEmailUnavaliable] = useState<boolean>(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    const activatePhysician = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSubmitDisabled(true);

        e.currentTarget.classList.add('was-validated');

        if (e.currentTarget.checkValidity()) {
            e.currentTarget.classList.remove('was-validated');
            var activateModel = new ActivateUser(props.model, email);
            activateModel.registerClientId = IdentityServerKnownClient.physicianPortal;

            abpnClient.post<boolean>('/api/profile/ValidateEmail', activateModel, null)
            .then(async isValid => {
                if (!isValid) {
                    setEmailUnavaliable(true);
                    setTimeout(() => {
                        setEmailUnavaliable(false);
                     }, 10000)
        
                    return;
                }
                props.onSave(activateModel);
            })
        }

        setIsSubmitDisabled(false);
    }

    return (
        <form onSubmit={(e) => activatePhysician(e)}>
            <Alert hidden={!emailUnavilable}variant="pp-alert-danger">Your portal account already exists with the email address you entered {email}.  Please login or reset password.</Alert>
            <Row>
                <Col>
                    <Card.Text className="pp-font-size-smaller font-weight-bolder">Please enter a personal email address below which will be used to log in to your ABPN Physician Portal account.</Card.Text>
                    <br />
                    <Card.Text className="pp-font-size-smaller">ABPN highly recommends keeping a personal email address on file to ensure you receive all communications regarding applications, exams, certification requirements, pertinent updates, and to access your ABPN Physician Portal account.</Card.Text>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                    <Form.Group controlId="email" className="mt-4">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Email Address
                            <span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Control type="email" required placeholder="johndoe@gmail.com"
                            onChange={(e) => setEmail(e.target.value)}
                            defaultValue={email} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button disabled={isSubmitDisabled} type="submit" variant="pp-primary">Send "Create Password" Email</Button>
                    <Link to="/">
                        <Button variant="outline-pp-primary" className="ml-4">Cancel</Button>
                    </Link>
                </Col>
            </Row>
        </form>
    );
}
